<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.site_list") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-lg-4.col-xl-4.mb-1
                b-input-group(size="sm")
                  b-form-select(v-model="searchType" size="sm" @change="initSearchData()" style="width:50px")
                    option(value="operator_id") {{ $t('ui.operator_id') }}
                    option(value="site_name") {{ $t('ui.site_name') }}
                  DebounceInput(autofocus type="text" v-model="searchData" :placeholder="$t('message.search_by_' + searchType)" @enter="getSiteList(true)" size="sm")

              .form-group.col-xl-2.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getSiteList(true)"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th.sortable(width="6%"  @click="sortOrder('site_id')")
                          span(:title="$t('ui.site_id')") {{ $t('ui.site_id') }}
                          .float-right
                            i(:class="changeSortKey('site_id')")
                        th.sortable(width="6%"  @click="sortOrder('external_id')")
                          span(:title="$t('ui.external_id')") {{ $t('ui.short.external_id') }}
                          .float-right
                            i(:class="changeSortKey('external_id')")
                        th.sortable(width="8%"  @click="sortOrder('operator_id')")
                          span(:title="$t('ui.operator_id')") {{ $t('ui.operator_id') }}
                          .float-right
                            i(:class="changeSortKey('operator_id')")
                        th.sortable(width="8%"  @click="sortOrder('site_name')")
                          span(:title="$t('ui.site_name')") {{ $t('ui.site_name') }}
                          .float-right
                            i(:class="changeSortKey('site_name')")
                        th(width="8%")
                          span(:title="$t('ui.theme_code')") {{ $t('ui.theme_code') }}
                        th(width="8%")
                          span(:title="$t('ui.theme_color')") {{ $t('ui.theme_color') }}
                        th.text-center(width="8%")
                          span(:title="$t('ui.logo')") {{ $t('ui.logo') }}
                        th(width="8%")
                          span(:title="$t('ui.draft_version')") {{ $t('ui.short.draft_version') }}
                        th(width="8%")
                          span(:title="$t('ui.prod_version')") {{ $t('ui.short.prod_version') }}
                        th.text-center(width="8%" v-if="isAbleAccess || isAbleAccessProviderOperator")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="siteList.length == 0")
                        td(colspan="15").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in siteList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td.buttons
                          span(:title="item.site_id") {{ item.site_id }}
                        td
                          span(:title="item.external_id") {{ item.external_id }}
                        td
                          span(:title="item.operator_id") {{ item.operator_id }}
                        td
                          span(:title="item.site_name") {{ item.site_name }}
                        td
                          span(:title="item.theme_code") {{ item.theme_code }}
                        td
                          span(:title="item.theme_color") {{ item.theme_color }}
                        td.align-middle.text-center
                          span(v-if="item.logo != null && item.logo != ''")
                            b-img(:src="imagePath + item.logo")
                          span(v-else)
                            span(:title="item.logo_text") {{ item.logo_text }}
                        td
                          span(:title="item.draft_version") {{ item.draft_version }}
                        td
                          span(:title="item.production_version") {{ item.production_version }}
                        td.text-center(v-if="isAbleAccess || isAbleAccessProviderOperator")
                          a.btn.btn-ssm.btn-icon.fa.fa-edit.btn-primary(
                            href="javascript:;"
                            :title="$t('ui.edit')"
                            @click="setSiteInfo(item)"
                            )

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import PackageLookup from "@/library/PackageLookup.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    PackageLookup
  },
  data: () => ({
    loading: false,
    siteList: [],
    siteStatus: "",
    themeCode: "",
    themeColor: "",
    imagePath: config.viewImageUrl,
    searchData: "",
    searchType: "operator_id",
    cartUserId: "",
    siteName: "",
    sortKey: "site_id",
    sortType: "desc",
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    getLanguage() {
      return this.$store.getters.language;
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isOperator() {
      return this.$store.getters.accountType === 2;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isAbleAccess() {
      return this.$helpers.showActionButton("siteinfo");
    },
    isAbleAccessProviderOperator() {
      return this.$helpers.showActionButton("provideroperator");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
    if(this.operatorID) {
      this.searchData = this.operatorID
      this.searchType = 'operator_id'
    }
    this.getSiteList(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getSiteList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    initSearchData() {
      this.searchData = "";

      this.getSiteList(true)
    },
    showActionButton() {
      if (this.$store.getters.authorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles = roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes('siteinfo')) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return true
      }
    },
    setSiteInfo: function(e) {
      this.$store.dispatch("user/setSelectedSiteID", e.site_id);
      this.$store.dispatch("user/setSelectedOperatorID", e.operator_id);
      this.$router.push("/site/siteinfo");
    },
    getDate(dateTime) {
      if(dateTime == null) return;
      let convertDateFormat = new this.$moment(dateTime).format("DD/MM/YYYY HH:mm:ss");
      return convertDateFormat;
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getSiteList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getSiteList();
    },
    getSiteList: function(isSearch) {
      let url = config.getSiteListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        currency: this.getCurrencyCode,
        page_number: this.currentPage,
        page_size: this.getPageSize,
        site_status: this.siteStatus,
        sort_key: this.sortKey,
        sort_type: this.sortType,
      }

      if (this.searchType == 'operator_id') {
        json.operator_id = this.searchData;
        if(this.searchData == '') {
          this.$store.dispatch("user/setSelectedOperatorID", '');
        }
      }

      if (this.searchType == 'site_name')
        json.site_name = this.searchData;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.siteList = response.data.dt;
                this.totalRow = this.siteList.length > 0 ? this.siteList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>